import React from 'react';

import Cropper from 'react-easy-crop';

import { Row, Col, Tabs, Form, Input, Button, Slider, Modal } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';

import LottieComponent from '@sharedComponent/lottie-component';
import ImageComponent from '@sharedComponent/image-component';
import { images } from '@assets/img';
import LottieFile from '@assets/lottiefiles';
import Header from '@sharedComponent/header/header';

import 'react-image-crop/lib/ReactCrop.scss';
import './profile.scss';

import { onlyAFFILIATE, onlyMERCHANT } from '@constants';
import { isAuth } from '@helpers';
import { useHistory } from 'react-router-dom';
import GifLoader from '@sharedComponent/gif-loader';
const layout = {
	labelCol: { span: 24 },
	wrapperCol: { span: 24 },
};
const layout1 = {
	labelCol: { span: 4 },
	wrapperCol: { span: 24 },
};
const { TabPane } = Tabs;
export const ProfilePresentational = ({
	onCropComplete,
	setZoom,
	crop,
	zoom,
	fileChange,
	deactivatecccount,
	deleteAccount,
	resetchangePswd,
	onFinishChangePassword,
	state,
	onFinish,
	clickInactive,
	clickDeleteAccount,
	removeImage,
	userDetails,
	setCrop,
	formRef,
	handlechange,
	imageUpload,
	formChangePasswordRef,
	setProfileVisible,
	profilevisible,
}) => {
	const history = useHistory();
	formRef.setFieldsValue({
		businessName: state.businessName || '',
		businessUrl: state.businessUrl || '',
		email: state.email || '',
		firstName: state.firstName || '',
		lastName: state.lastName || '',
		password: state.password || '',
		phone: state.phone || '',
		userId: state.userId || '',
		userName: state.userName || '',
		authKey: state.authKey || '',
		userStatus: state.userStatus || '',
		accessLevel: state.accessLevel || '',
	});
	const { loading, saveAllButton, uploadAllButton, deactivateAccountButton, deleteAccountButton, updateButton } = state;
	return (
		<>
			{loading ? (
				<Col style={{ display: 'flex', height: '100vh', justifyContent: 'center', alignItems: 'center' }}>
					{/* <LottieComponent width="10%" height="10%" file={LottieFile.Loading} /> */}
					<GifLoader />
				</Col>
			) : (
					<>
						<Header title={'Profile / Profile Management'} showAccessLevel hideAddAffiliate />
						<Row className="profile_container">
							<Col className="back_card">
								<Tabs defaultActiveKey="1" className="card_tabs">
									<TabPane tab="CRM Affiliate Portal User Profile Management" className={`${loading ? 'flc' : ''}`} key="1">
										<Row className="profile_body_flex">
											<Col xl={12} lg={24} md={24} sm={24} xs={24} className="pad_card">
												<Form
													style={{ marginTop: '30px' }}
													hideRequiredMark={true}
													{...layout}
													layout="vertical"
													name="control-ref"
													form={formRef}
													initialValues={{
														businessUrl: state.businessUrl,
														email: state.email,
														firstName: state.firstName,
														lastName: state.lastName,
														password: state.password,
														phone: state.phone,
														userId: state.userId,
														userName: state.userName,
														authKey: state.authKey,
														userStatus: state.userStatus,
														accessLevel: state.accessLevel,
													}}
													onFinish={onFinish}>
													<Form.Item validateTrigger={['onBlur']} className="noreq" name="userName" label="Username">
														<Input disabled prefix={<ImageComponent className="proicon" src={images.user} />} />
													</Form.Item>
													<Row>
														<Col lg={{ span: 11 }} md={{ span: 24 }} sm={{ span: 24 }}>
															<Form.Item
																validateTrigger={['onBlur']}
																className="noreq"
																name="firstName"
																label="First Name"
																rules={[
																	{
																		required: true,
																		message: 'Invalid First Name!',
																	},
																	{
																		min: 3,
																		message: 'First Name must be atleast 3 characters!',
																	},
																	{
																		pattern: new RegExp(/^[_A-z]*((-|\s)*[_A-z])*$/),
																		message: 'First Name cannot contain special characters & numbers',
																	},
																]}>
																<Input
																	onChange={(e) => handlechange('firstName', e.target.value)}
																	prefix={<ImageComponent className="proicon" src={images.user} />}
																/>
															</Form.Item>
														</Col>
														<Col lg={{ span: 2 }}></Col>
														<Col lg={{ span: 11 }} md={{ span: 24 }} sm={{ span: 24 }}>
															<Form.Item
																validateTrigger={['onBlur']}
																className="noreq"
																name="lastName"
																label="Last Name"
																rules={[
																	{
																		required: true,
																		message: 'Invalid Last Name!',
																	},
																	{
																		pattern: new RegExp(/^[_A-z]*((-|\s)*[_A-z])*$/),
																		message: 'Last Name cannot contain special characters & numbers',
																	},
																]}>
																<Input onChange={(e) => handlechange('lastName', e.target.value)} prefix={' '} />
															</Form.Item>
														</Col>
													</Row>

													<Form.Item
														validateTrigger={['onChange', 'onBlur']}
														className="noreq"
														name="email"
														label="E-mail address"
														rules={[
															{
																required: true,
																message: 'Please input your E-mail address!',
															},
															{
																type: 'email',
																message: 'Please input a valid email (Ex: abc@example.com)',
															},
														]}>
														<Input
															type="email"
															onChange={(e) => handlechange('email', e.target.value)}
															prefix={<ImageComponent className="proicon" src={images.mail} />}
														/>
													</Form.Item>
													<Form.Item validateTrigger={['onBlur']} className="noreq" name="accessLevel" label="Access Level">
														<Input disabled prefix={<ImageComponent className="proicon" src={images.user} />} />
													</Form.Item>
													<Form.Item
														validateTrigger={['onBlur']}
														className="noreq"
														name="phone"
														label="Phone Number"
														rules={[
															{
																required: true,
																message: 'Invalid Phone Number!',
															},
															{
																min: 10,
																message: 'Phone Number must be atleast 10 characters',
															},
															{
																max: 10,
																message: 'Phone Number must be maximum 10 characters',
															},
														]}>
														<Input
															type="number"
															onChange={(e) => handlechange('phone', e.target.value)}
															prefix={<ImageComponent className="proicon" src={images.phone} />}
														/>
													</Form.Item>
													{isAuth(onlyMERCHANT, userDetails && userDetails.accessLevel) ? (
														<Form.Item
															validateTrigger={['onBlur']}
															className="noreq"
															name="businessName"
															label="Company Name"
															rules={[
																{
																	required: true,
																	message: 'Invalid Company Name!',
																},
																{
																	min: 3,
																	message: 'Company Name must be atleast 3 characters',
																},
															]}>
															<Input disabled
																onChange={(e) => handlechange('businessName', e.target.value)}
																prefix={<ImageComponent className="proicon" src={images.business} />}
															/>
														</Form.Item>
													) : null}
													{isAuth(onlyAFFILIATE, userDetails && userDetails.accessLevel) ? (
														<Row>
															<Col lg={{ span: 11 }} md={{ span: 24 }} sm={{ span: 24 }}>
																<Form.Item
																	validateTrigger={['onBlur']}
																	className="noreq"
																	name="businessName"
																	label="Business Name">
																	<Input
																		onChange={(e) => handlechange('businessName', e.target.value)}
																		prefix={<ImageComponent className="proicon" src={images.business} />}
																	/>
																</Form.Item>
															</Col>
															<Col lg={{ span: 2 }}></Col>
															<Col lg={{ span: 11 }} md={{ span: 24 }} sm={{ span: 24 }}>
																<Form.Item validateTrigger={['onBlur']} className="noreq" name="businessUrl" label="URL">
																	<Input
																		onChange={(e) => handlechange('businessUrl', e.target.value)}
																		prefix={<ImageComponent className="proicon" src={images.web} />}
																	/>
																</Form.Item>
															</Col>
														</Row>
													) : null}
													<Row>
														<Col lg={{ span: 15 }} md={{ span: 15 }} sm={{ span: 15 }} style={{ width: '100%' }}>
															<Form.Item
																validateTrigger={['onBlur']}
																className="noreq"
																name="password"
																label="Password"
																rules={[
																	{
																		required: false,
																		message: 'Invalid Password!',
																	},
																]}>
																<Input
																	disabled
																	prefix={<ImageComponent className="proicon" src={images.lock} />}
																	type="password"
																/>
															</Form.Item>
														</Col>
														<Col lg={{ span: 1 }} md={{ span: 1 }} sm={{ span: 1 }}></Col>
														<Col
															lg={{ span: 8 }}
															style={{ width: '100%' }}
															sm={{ span: 8 }}
															md={{ span: 8 }}
															className="reset_pswd_btn_area">
															<Button
																className="reset_btn"
																onClick={() => setProfileVisible(true)}
																style={{
																	height: '45px',
																	marginTop: '10px',
																}}>
																Change Password
														</Button>
														</Col>
													</Row>

													<Form.Item>
														<Col className="btn_area_bottom">
															<Button className="cancel_btn" onClick={() => history.push('/dashboard')}>
																Cancel
														</Button>
															<Button className="save_btn" htmlType="submit" loading={saveAllButton}>
																Save All
														</Button>
														</Col>
													</Form.Item>
												</Form>
												<Col>
													<Row className="onlySm">
														<Col
															xl={{ span: 8 }}
															lg={{ span: 10 }}
															md={{ span: 24 }}
															sm={{ span: 24 }}
															className="acc_btn_area">
															{/* <Button className="inactive_btn" onClick={clickInactive}>
															Deactivate Account
														</Button> */}
														</Col>

														<Col lg={{ span: 10 }} md={{ span: 24 }} sm={{ span: 24 }} className="acc_btn_area">
														{isAuth(onlyAFFILIATE, userDetails && userDetails.accessLevel) &&<Button className="delete_acc_btn" onClick={clickDeleteAccount}>
																Delete Account
														</Button>}
														</Col>
													</Row>
												</Col>
											</Col>
											<Col xl={12} lg={24} md={24} sm={24} xs={24} className="pad_card">
												<Row>
													<Col xl={2} lg={0} md={0} sm={0} xs={0}></Col>
													<Col xl={22} lg={24} md={24} sm={24} xs={24} className="crop_imge_araea">
														{!state.imageSrc ? (
															<Row>
																<Col className="empty_img">{'  '}</Col>
																<Col className="empty_img">{'  '}</Col>
																<Col className="empty_img">{'  '}</Col>
																<Col className="empty_img">{'  '}</Col>
																<Input
																	type="file"
																	name="upload"
																	accept="image/*"
																	id="upload"
																	onChange={(e) => fileChange(e.target.files)}
																	style={{ display: 'none' }}
																/>
																<label
																	className="Upload_btn"
																	htmlFor="upload"
																	style={{ color: '#0167eb', width: '100%', cursor: 'pointer', fontSize: '15px' }}>
																	<Col className="empty_img">{' Click to browse Media'}</Col>
																</label>
																<Col className="empty_img">{'  '}</Col>
																<Col className="empty_img">{'  '}</Col>
																<Col className="empty_img">{'  '}</Col>
																<Col className="empty_img">{'  '}</Col>
																<Col className="empty_img">{'  '}</Col>
															</Row>
														) : null}

														{state.imageSrc ? (
															<Col className="reset_img_area">
																<Col>Resize Image</Col>
																<Col style={{ textAlign: 'right' }}>
																	<DeleteOutlined style={{ color: 'red' }} onClick={removeImage} />
																	{/* <CloseOutlined onClick={removeImage} /> */}
																</Col>
															</Col>
														) : null}
														{state.imageSrc ? (
															<Col className="crop_img">
																<Cropper
																	image={state.imageSrc}
																	crop={state.crop}
																	zoom={state.zoom}
																	aspect={4 / 4}
																	onCropChange={setCrop}
																	onCropComplete={onCropComplete}
																	onZoomChange={setZoom}
																/>
															</Col>
														) : null}
														{state.imageSrc ? (
															<Col lg={{ span: 24 }}>
																<Form {...layout1} layout="horizontal">
																	<Form.Item className="lael" label="Zoom">
																		<Slider
																			min={1}
																			max={20}
																			defaultValue={state.zoom}
																			onAfterChange={(e) => handlechange('zoom', e)}
																		/>
																	</Form.Item>
																</Form>
															</Col>
														) : null}

														<Col>
															<Col className="Upload_btn_area">
																<Button
																	disabled={!state.basecroppedImage}
																	className="Upload_btn"
																	onClick={imageUpload}
																	htmlType="submit"
																	loading={uploadAllButton}>
																	Upload
															</Button>
																{/* <Input
																name="upload1"
																id="upload1"
																style={{ display: 'none' }}
															/>
															<label className="Upload_btn" htmlFor="upload1">
																Upload
															</label> */}
															</Col>
														</Col>
													</Col>
													<Col xl={2} lg={0} md={0} sm={0} xs={0}></Col>
												</Row>
												<Row className="onlyLgflex">
													<Col xl={4} lg={24} md={24} sm={24} xs={24} className="acc_btn_area" style={{ marginTop: '30px' }}>
														{/* <Button className="inactive_btn" onClick={clickInactive}>
														Deactivate Account
													</Button> */}
													</Col>
													<Col xl={4} lg={0} md={0} sm={0} xs={0}></Col>
													<Col xl={10} lg={24} md={24} sm={24} xs={24} className="acc_btn_area" style={{ marginTop: '30px' }}>
													{isAuth(onlyAFFILIATE, userDetails && userDetails.accessLevel) &&<Button className="delete_acc_btn" onClick={clickDeleteAccount}>
															Delete Account
													</Button>}
													</Col>
												</Row>
											</Col>
										</Row>
									</TabPane>
								</Tabs>
							</Col>

							<Modal
								visible={state.inactivevisible}
								title={null}
								centered={true}
								footer={null}
								closable={false}
								className="inactive_modal_area">
								<Col className="inactive_modal_header">Deactive Account</Col>
								<Col className="inactive_modal_body">
									<Col style={{ textAlign: 'center', marginBottom: '20px', marginTop: '20px' }}>
										<ImageComponent style={{ maxWidth: '250px' }} src={images.deactiveimg} />
									</Col>
									<Col className="inactive_modal_body_content">Your Account will be temporarily deactived</Col>
								</Col>
								<Col className="inactive_modal_footer">
									<Button className="cancel_btn" onClick={() => handlechange('inactivevisible', false)}>
										Cancel
								</Button>
									<Button className="inactive_btn" onClick={() => deactivatecccount()} loading={deactivateAccountButton}>
										Deactivate Account
								</Button>
								</Col>
							</Modal>

							<Modal
								visible={state.deletevisible}
								title={null}
								centered={true}
								footer={null}
								closable={false}
								className="delete_modal_area">
								<Col className="delete_modal_header">
									<ImageComponent style={{ paddingRight: '20px' }} src={images.user} />
								Delete Account
							</Col>
								<Col className="delete_modal_body">
									<Col style={{ textAlign: 'center', marginBottom: '20px', marginTop: '20px' }}>
										<ImageComponent style={{ maxWidth: '250px' }} src={images.deleteimg} />
									</Col>
									<Col className="delete_modal_body_content">
										You are about to delete your account. Once your account has been deleted, all data will be removed. Please confirm
										that you want to delete your account
								</Col>
								</Col>
								<Col className="delete_modal_footer">
									<Button className="cancel_btn" onClick={() => handlechange('deletevisible', false)}>
										Cancel
								</Button>
								{isAuth(onlyAFFILIATE, userDetails && userDetails.accessLevel) &&<Button className="delete_btn" onClick={deleteAccount} loading={deleteAccountButton}>
										Delete Account
								</Button>}
								</Col>
							</Modal>

							<Modal
								visible={profilevisible}
								title={'Reset Password'}
								centered={true}
								footer={null}
								closable={true}
								className="delete_modal_area"
								onCancel={resetchangePswd}>
								<Col className="delete_modal_body">
									<Row className="profile_container">
										<Col lg={{ span: 2 }}></Col>
										<Col lg={{ span: 20 }}>
											<Form {...layout} hideRequiredMark={true} onFinish={onFinishChangePassword} form={formChangePasswordRef}>
												<Form.Item className="noreq" name="currentPassword" label="Current Password">
													<Input.Password className="he_pswd" />
												</Form.Item>
												<Form.Item
													validateTrigger={['onBlur']}
													className="noreq"
													name="newPassword"
													label="New Password"
													rules={[
														{
															required: true,
															message: 'This field is required ',
															// message: 'Please input your Password !',
														},
														{
															min: 8,
															message: 'Password must be a minimum of 8 characters.',
														},
														{
															pattern: new RegExp(/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])[A-Za-z\d@.,$^!%*?&]{8,}$/),
															message:
																'Must contain 1 uppercase letter, 1 lowercase letter and a number and/or special character. ',
														},
													]}>
													<Input.Password className="he_pswd" />
												</Form.Item>
												<Form.Item
													validateTrigger={['onBlur']}
													className="noreq"
													name="confirmPassword"
													label="Confirm Password"
												// rules={[
												// 	{
												// 		required: true,
												// 		message: 'Please input your Password !',
												// 	},
												// 	{
												// 		min: 8,
												// 		message: 'Password must be a minimum of 8 characters.',
												// 	},
												// 	{
												// 		pattern: new RegExp(/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])[A-Za-z\d@.,$^!%*?&]{8,}$/),
												// 		message:
												// 			'Must contain 1 uppercase letter, 1 lowercase letter and a number and/or special character. ',
												// 	},
												// ]}
												>
													<Input.Password className="he_pswd" />
												</Form.Item>
												<Col
													className="delete_modal_footer"
													style={{ justifyContent: 'flex-end', padding: '25px 0px', margin: 0 }}>
													<Button className="cancel_btn max_wd_200" onClick={resetchangePswd}>
														Cancel
												</Button>
													<Button className="update_btn max_wd_200" htmlType="submit" loading={updateButton}>
														Update
												</Button>
												</Col>
											</Form>
										</Col>
										<Col lg={{ span: 2 }}></Col>
									</Row>
								</Col>
							</Modal>
						</Row>
					</>
				)}
		</>
	);
};
